import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GhostButtonComponent } from '@x/ecommerce-shop/app/core/shop-ui/components/ghost-loading/ghost-button/ghost-button.component';
import { GhostAddToCartComponent } from './ghost-add-to-cart.component';

@NgModule({
  declarations: [GhostAddToCartComponent],
  imports: [CommonModule, GhostButtonComponent],
  exports: [GhostAddToCartComponent],
})
export class GhostAddToCartModule {}
